import $ from 'jquery';
import {heightToggle} from '../../scripts/util/animate/heightAnimate';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-exchange-return',
			dom: {
				link: '.js-exchange-return-link',
				content: '.js-exchange-return-content',
				info: '.js-exchange-return-info',
				shows: '.js-link-hide'
			},
			classes: {
				el: {
					state: {
						open: 'exchange-return__content_state_open',
						show: 'exchange-return__wrap-link_state_show'
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
	}

	getDom() {
		this.$link = this.$el.find(this.options.dom.link);
		this.$content = this.$el.find(this.options.dom.content);
		this.$shows = this.$el.find(this.options.dom.shows);
		this.$info = this.$el.find(this.options.dom.info);
	}

	onClick = () => {
		const openClass = this.options.classes.el.state.open;
		heightToggle(this.$content, openClass);
		this.$content.toggleClass(openClass);
	}

	onShow = e => {
		const $target = $(e.target);
		const $wrap = $target.parent();
		const openClass = this.options.classes.el.state.show;
		heightToggle($wrap, openClass, this.$info);
		$wrap.toggleClass(openClass);
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$link.on('click', this.onClick);
			this.$shows.on('click', this.onShow);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/exchange-return/exchange-return.js
 **/